/* eslint-disable import/no-cycle */
import { logger } from '../../utils';
import FeaturedContentSideBySide from '../../components/FeaturedContentSideBySide';
import { CType } from '../../models/Contentful/types';
import { IFeaturedContentSideBySideBladeProps } from './@types';

const FeaturedContentSideBySideBlade: React.FC<
  CType<IFeaturedContentSideBySideBladeProps>
> = props => {
  try {
    const {
      fields: { ...data },
    } = props;
    return <FeaturedContentSideBySide {...data} />;
  } catch (error) {
    logger.error(error);
    return null;
  }
};
export default FeaturedContentSideBySideBlade;
